module.exports = __webpack_public_path__ + "static/img/1@2x.793e55e.png";


//////////////////
// WEBPACK FOOTER
// ./static/1@2x.png
// module id = R7Oh
// module chunks = 1